/* unplugin-vue-components disabled */import { render } from "./DeviceSystem.vue?vue&type=template&id=6980ebae&scoped=true"
import script from "./DeviceSystem.vue?vue&type=script&lang=js"
export * from "./DeviceSystem.vue?vue&type=script&lang=js"

import "./DeviceSystem.vue?vue&type=style&index=0&id=6980ebae&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6980ebae"]])

export default __exports__